import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CSSObject } from 'styled-components';

import type { SortableItemProps } from './SortableItem.typed';

const SortableItem = (props: SortableItemProps) => {
  const { id, children } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: CSSObject = {
    transform: CSS.Transform.toString(transform),
    transition,
    transformOrigin: '50% 50%',
    cursor: isDragging ? 'grabbing' : 'grab',
    position: 'relative',
    zIndex: isDragging ? 2 : 1,
  };

  return (
    <div ref={setNodeRef} {...attributes} {...listeners} style={style}>
      {children}
    </div>
  );
};

export default SortableItem;
